import RankedList from "../../components/RankedList.jsx";
import PeriodBanner from "./suggestionTab/PeriodBanner.jsx";
import SuggestionSerchForm from "./suggestionTab/SuggestionSearchForm.jsx";
import SuggestionsResults from "./suggestionTab/SuggestionsResults.jsx";


export function SuggestionsTab(props) {
    console.log("SuggestionsTab received onSetDeadline:", props.onSetDeadline);
    const isVotingActive = props.suggestions.isVotingActive;

    function openBookDetailsACB(bookId) {
        props.searchBook(bookId);
    }
    return (
        <div>
            <div className="space-y-6 mb-4">
                <PeriodBanner
                    isVotingActive={props.suggestions.isVotingActive}
                    isAdmin={props.isAdmin} 
                    votingDeadline={props.suggestions.votingDeadline}
                    suggestions={props.suggestions.suggestedBooks.length}
                    endVotingPeriod={() => props.onEndVotingPeriod()}
                    extendVotingPeriod={(date) => props.onStartVotingPeriod(date)}
                />
            </div>        
            <div className="mb-4 bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 !border border-amber-200">
                <RankedList 
                    suggestions={props.suggestions}
                    bookClub={props.currentClub}
                    currentUser={props.currentUser}
                    setShowBookDetail={openBookDetailsACB}
                    onVote={(bookId, userId, score) => (console.log("Voting from SuggestionsTab:", bookId, userId, score), props.vote(bookId, userId, score))}
                    isAdmin={props.isAdmin}
                    onChoosenBook={(book) => props.onChoosenBook(book)}
                    onStartVotingPeriod={(date) => props.onStartVotingPeriod(date)}
                    isVotingActive={isVotingActive}
                    onSetReadingDeadline={props.onSetDeadline}
                />
            </div>
            {isVotingActive && (
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 !border border-amber-200">
                <h3 className="text-amber-900 mb-4">Search for a Book to Suggest</h3>
                {/* Search Input */}
                <SuggestionSerchForm
                    setSearchParams={(params) => props.setSearchParams(params)}
                    doSearch={() => props.doSearch()}
                />
                {/* Search Results */}
                <SuggestionsResults 
                    createPopUp={(event) => console.log(event)}
                    status={props.status}
                    searchResults={props.searchResults}
                    error={props.error}
                    searchResultId={props.searchResultId}
                    statusId={props.statusId}
                    errorId={props.errorId}
                    onOpenDetails={openBookDetailsACB}
                    onCloseDetails={() => props.cancelPopUp()}
                    addSuggestion={(book) => props.addSuggestion(book)}
                    checkIfSuggested={(bookId) => props.suggestions.suggestedBooks.some(b => b.bookId === bookId)}
                />
            </div>
            )}
        </div>
    );
}
